module.exports = __webpack_public_path__ + "static/media/boat-img-26.305ea81e.jpg";